// 指定コンテンツをダウンロードする
export const downloadFile = (
  filename: string,
  content: string | ArrayBuffer, // binaryをutf8でデコードした文字列を渡すと想定していないエラーになるかもしれないので、binaryの場合はArrayBufferで使用する
  mime: string
) => {
  const blob = new Blob([content], {
    type: mime,
  });

  const blobURL = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobURL;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.parentNode?.removeChild(a);
};
